<script>
  import {
    PUBLIC_DEFAULT_LANGUAGE,
    PUBLIC_DEFAULT_CURRENCY
  } from '$env/static/public'

  import { setLanguage, setCurrency } from '$lib/context.js'
  import { setGraphQLContext } from '$lib/graphql.svelte.js'
  import Meta from '$lib/Meta.svelte'

  import '$lib/main.css'

  let { children } = $props()

  setGraphQLContext({ url: '/api' })

  setLanguage(PUBLIC_DEFAULT_LANGUAGE)
  setCurrency(PUBLIC_DEFAULT_CURRENCY)

  const onkeydown = (event) => {
    if (event.key === 'Tab') {
      document.documentElement.classList.add('using-keyboard')
    }
  }

  const release = () => {
    document.documentElement.classList.remove('using-keyboard')
  }
</script>

<svelte:window
  on:keydown={onkeydown}
  on:mousedown={release}
  on:touchstart={release} />

{@render children()}

<svelte:head>
  <Meta root />
</svelte:head>
